export class FinalWidget{

	static _defaults = null;

	static addPlugins( ...plugins ){
		if( this._defaults === null )
			this._initDefaults();

		plugins.map((p) => p.apply( this, [this._defaults] ) )
	}


	applyEvents( section, prefix, args ){

		this.params.on[section].map((e) => e.apply(this, args));

		// Global events
		document.dispatchEvent(
			new CustomEvent(
				prefix + "_" + section,
				{
			  		detail: args,
				}
			)
		)
	}

}

export class EventsSet{

	events = {};
	constructor( ...events ){
		this.addEvents(...events);
	}

	addEvents( ...events ){
		events.map((e) => this.events[e] = []);
	}

	cloneMerge( param ){

		let clone = this.constructor.init( ...Object.keys( this.events ) );

		for( let event in this.events ){
			
			this.events[ event ].map( (cb) => clone[event] = cb );

			if( param[event] ){
				if( Array.isArray( param[event] ) )
					param[event].map((cb) => clone[event] = cb );
				else
					clone[event] = param[event]
			}
		}

		return clone;

	}

	static init( ...events ){
		let self = new EventsSet(...events);

		return new Proxy(
			self,
			this.#getProxyHandlers( self )
		)
	}

	static #getProxyHandlers( self ){
		return {
			get( self, prop, receiver ){

				if( self.events[prop] )
					return self.events[prop];

				if(self[prop] instanceof Function) 
					return self[prop].bind(self);

				if( ! self.events.hasOwnProperty(prop) ){
					throw `No such event ${prop}`;
				}

			},
			set( self, prop, handler, receiver ){

				if( ! self.events.hasOwnProperty(prop) ){
					throw `No such event ${prop}`;
				}

				self.events[prop].push(handler);
				return true;
			}
		};
	}

}


export function mergeObjects( params, defaults ){

	let effective = {};
	for( let i in defaults ){
		if( params.hasOwnProperty(i) ){

			if( typeof(defaults[i]) === 'object' && defaults[i] !== null ){

				if( !params[i] ){
					effective[i] = params[i];
					continue;
				}

				let proto = Object.getPrototypeOf(defaults[i])

				if( proto === Object.prototype || proto === null ){

					effective[i] = mergeObjects( params[i], defaults[i] )

				} else if( defaults[i].cloneMerge ){

					effective[i] = defaults[i].cloneMerge( params[i] )

				} else{
					// TODO:: arrays merge
					throw "Cannot merge unclonable object";
				}

			} else if( Array.isArray( defaults[i] ) ){

				// TODO:: arrays merge
				throw "Cannot merge arrays atm";

			} else{
				effective[i] = params[i]
			}

		} else{
			effective[i] = defaults[i];
		}
	}

	return effective;
}



export class CubicBezier{

	constructor( p0, p1, p2, p3 ){
		this.points = [];
		[p0,p1,p2,p3].map((p) => this.points.push({x: p[0], y: p[1]}));
	}

	coords( t ){

		let out = {};

		['x','y'].map((coord) => {

			out[coord] = 
				Math.pow( 1 - t, 3 ) * this.points[0][coord]
				+ 3 * t * Math.pow( 1 - t, 2 ) * this.points[1][coord]
				+ 3 * Math.pow( t, 2 ) * ( 1 - t ) * this.points[2][coord]
				+ Math.pow( t, 3 ) * this.points[3][coord]

		});

		return out;

	}



}




export class Utils{

	static clamp( v, low_bounbdary, high_boundary ){
		return Math.min( high_boundary, Math.max( low_bounbdary, v ) );
	}

}
